export default __webpack_public_path__ + "0c4af6847fe0c77283cc615d3fd8eb7d.png";